class DapDialogController extends HTMLElement {
  #triggerEl = null;
  #wrapper = null;

  connectedCallback() {
    document.addEventListener("dap:session-complete", this.#onComplete);
    this.#wrapper = this.closest("dialog-component");
    this.#wrapper?.addEventListener("dialog:close", this.#onDialogClose);

    document.addEventListener("pointerdown", this.#captureOpenerPointer);
    document.addEventListener("keydown", this.#captureOpenerKey);
  }

  disconnectedCallback() {
    document.removeEventListener("dap:session-complete", this.#onComplete);
    this.#wrapper?.removeEventListener("dialog:close", this.#onDialogClose);
    this.#wrapper = null;

    document.removeEventListener("pointerdown", this.#captureOpenerPointer);
    document.removeEventListener("keydown", this.#captureOpenerKey);

    this.#triggerEl = null;
  }

  #captureOpenerPointer = (e) => {
    const trigger = e.target.closest("[data-dap-trigger]");
    if (trigger) this.#triggerEl = trigger;
  };

  #captureOpenerKey = (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;
    const trigger = e.target.closest("[data-dap-trigger]");
    if (trigger) this.#triggerEl = trigger;
  };

  #onComplete = () => {
    this.closest("dialog-component")?.closeDialog();
  };

  #onDialogClose = () => {
    if (this.#triggerEl?.isConnected) {
      this.#triggerEl.focus();
    }
    this.#triggerEl = null;
  };
}

if (typeof customElements !== "undefined") {
  if (!customElements.get("dap-dialog-controller")) {
    customElements.define("dap-dialog-controller", DapDialogController);
  }
}
